/**
 * dialogify
 * https://github.com/OneupNetwork/dialogify
 */
(function($, window, dialogPolyfill, undefined){
    'use strict';

    var Dialogify = function(source, options){
        var dialog = window.document.createElement('dialog');
        dialogPolyfill.registerDialog(dialog);

        if (options == null || typeof options != 'object') {
            options = {};
        }

        this.options = options;

        var ajaxPrefix = options.ajaxPrefix === undefined ? '/ajax/' : options.ajaxPrefix;

        var self = this;
        var content;
        var ajax = false;
        if (source.charAt(0) == '#') {
            content = $(source).html();
        } else if(source.indexOf(ajaxPrefix) == 0){
            var loadingSvg = 'data:image/svg+xml;base64,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';
            content = '<div class="dialogify-ajax-content"><img class="dialogify-ajax-loading" src="' + loadingSvg + '"></div>';
            ajax = true;
        } else {
            content = source;
        }

        content  = '<div class="dialogify__body">' + content + '</div>';

        var widthClass = options.size || 'dialogify__fixedwidth';
        var dialogClass = 'dialogify';
        if (options.fixed !== false) {
            dialogClass += ' fixed';
        }

        var dialogHtml = '<div class="dialogify__content ' + widthClass + '"><div></div></div>';

        if (options.useDialogForm !== false) {
            var edgeSubmitIssue = /(?:edge|iPad)/i.test(window.navigator.userAgent) ? ' onsubmit="return false;"' : '';
            dialogHtml = '<form method="dialog"' + edgeSubmitIssue + '>' + dialogHtml + '</form>';
        }

        this.id = 'dialogify_' + (++Dialogify.counter);

        $(dialog).attr('id', this.id)
            .addClass(dialogClass)
            .append(dialogHtml).append($closeButton)
            .on('close', function(e){
                $(self).triggerHandler('close');
                $(this).remove();
            })
            .on('cancel', function(e){
                $(self).triggerHandler('cancel');
                if (options.closable === false) {
                    e.preventDefault();
                }
            })
            .click(function(e){
                if (options.closable !== false && e.target == dialog) {
                    $(self).triggerHandler('cancel');
                    dialog.close();
                }
            })
            .appendTo('body');

        if (options.closable !== false) {
            var $closeButton = $('<a>').addClass('dialogify__close')
                .append('<img src="data:image/svg+xml;base64,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">')
                .click(function(e){
                    $(dialog).triggerHandler('cancel');
                    $(dialog).triggerHandler('close');
                });

            $(dialog).append($closeButton);
        }

        this.$content = $(dialog).find('.dialogify__content > div');
        this.$content.append(content);

        if (ajax) {
            $.get(source, options.ajaxData || {}, function(resp){
                if (options.ajaxComplete) {
                    options.ajaxComplete.call(self);
                }

                self.$content.find('.dialogify-ajax-content').html(resp);
            }, 'html');
        }

        this.showModal = function(){
            dialog.showModal();
            $(this).triggerHandler('show');
        };

        this.show = function(){
            dialog.show();
            $(this).triggerHandler('show');
        };

        this.close = function(){
            dialog.close();
        };

        this.isOpen = function(){
            return dialog.open;
        };

        this.on = function(event, handler){
            $(this).on(event, handler);
            return this;
        };
    };

    Dialogify.prototype.title = function(title){
        var $titleBox = $('<h5>').addClass('dialogify_title')
            .append('<img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iJiN4NTcxNjsmI3g1QzY0O18xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDEyIDEwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMiAxMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxyZWN0IHk9IjEiIHN0eWxlPSJmaWxsOiM4RDhEOEQ7IiB3aWR0aD0iMyIgaGVpZ2h0PSIzIi8+PHJlY3QgeT0iNyIgc3R5bGU9ImZpbGw6IzhEOEQ4RDsiIHdpZHRoPSIzIiBoZWlnaHQ9IjMiLz48cmVjdCB4PSIzIiB5PSI0IiBzdHlsZT0iZmlsbDojOEQ4RDhEOyIgd2lkdGg9IjMiIGhlaWdodD0iMyIvPjwvZz48L3N2Zz4=">')
            .append(title);

        if (this.$content.find('.dialogify_title').length) {
            this.$content.find('.dialogify_title').replaceWith($titleBox);
        } else {
            this.$content.prepend($titleBox);
        }

        return this;
    }

    Dialogify.prototype.buttons = function(buttons, options){
        if (!Array.isArray(buttons)) {
            buttons = [];
        }

        if (options == null || typeof options != 'object') {
            options = {};
        }

        this.$buttonList = {};

        var $buttonBox = $('<div>')
            .addClass('btn-box')
            .addClass(options.position || 'text-right');

        var self = this;
        for (var i = 0;i < buttons.length;i++){
            if (typeof buttons[i] == 'string') {
                var $btn = $(buttons[i]);
                var btnId = $btn.attr('id') || i;
                this.$buttonList[btnId] = $btn;
                $buttonBox.append($btn);
            } else {
                if (buttons[i] == null || typeof buttons[i] != 'object') {
                    buttons[i] = {};
                }

                var $btn = $('<button type="button">')
                    .addClass('btn btn-insert')
                    .addClass(buttons[i].type || '')
                    .data('click', buttons[i].click);

                if (buttons[i].type == Dialogify.BUTTON_PRIMARY && this.options.useDialogForm !== false) {
                    $btn.attr('type', 'submit');
                }

                if (buttons[i].focused) {
                    $btn.prop('autofocus', true);
                }

                if (buttons[i].disabled) {
                    $btn.disable();
                }

                $btn.text(buttons[i].text || '關閉');
                $btn.click(function(e){
                    if (typeof $(this).data('click') == 'function') {
                        $(this).data('click').call(self, e);
                    }
                });

                this.$buttonList[buttons[i].id || i] = $btn;
                $buttonBox.append($btn);
            }
        }

        if (this.$content.find('.btn-box').length) {
            this.$content.find('.btn-box').replaceWith($buttonBox);
        } else {
            this.$content.append($buttonBox);
        }

        return this;
    }

    Dialogify.counter = 0;

    Dialogify.SIZE_LARGE = 'dialogify__autowidth';

    Dialogify.BUTTON_CENTER = 'text-center';
    Dialogify.BUTTON_LEFT = 'text-left';

    Dialogify.BUTTON_PRIMARY = 'btn-primary';
    Dialogify.BUTTON_DANGER = 'btn-danger';

    Dialogify.alert = function(message){
        new Dialogify('<p>' + message + '</p>', {closable: false})
            .buttons([{
                type: Dialogify.BUTTON_DANGER,
                click: function(){
                    this.close();
                }
            }], {position: Dialogify.BUTTON_CENTER})
            .showModal();
    };

    Dialogify.confirm = function(message, options){
        if (options == null || typeof options != 'object') {
            options = {};
        }

        new Dialogify('<p>' + message + '</p>')
            .buttons([
                {
                    text: '取消',
                    click: function(e){
                        options.cancel && options.cancel.call(this);
                        this.close();
                    }
                },
                {
                    text: '確定',
                    type: Dialogify.BUTTON_PRIMARY,
                    focused: true,
                    click: function(e){
                        options.ok && options.ok.call(this);
                        this.close();
                    }
                }
            ])
            .on('cancel', function(){
                options.cancel && options.cancel.call(this);
            })
            .showModal();
    };

    Dialogify.prompt = function(message, options){
        if (options == null || typeof options != 'object') {
            options = {};
        }

        var placeholder = options.placeholder ? ' placeholder="' + options.placeholder + '"' : '';
        var $html = $('<div>').html('<p>' + message + '</p>');
        $html.append('<input type="text" class="text-field dialogify-prompt-input"' + placeholder + '>');

        new Dialogify($html.html())
            .buttons([
                {
                    text: '取消',
                    click: function(e){
                        options.cancel && options.cancel.call(this);
                        this.close();
                    }
                },
                {
                    text: '確定',
                    type: Dialogify.BUTTON_PRIMARY,
                    click: function(e){
                        var value = this.$content.find('.dialogify-prompt-input').val();
                        options.ok && options.ok.call(this, value);
                        this.close();
                    }
                }
            ])
            .on('cancel', function(){
                options.cancel && options.cancel.call(this);
            })
            .showModal();
    };

    // inject css
    if (!$('#dialogifyCss').length) {
        $('<style>')
            .attr({type: 'text/css', id: 'dialogifyCss'})
            .html('.dialogify{display:none;position:absolute;top:50%;bottom:auto;left:50%;right:auto;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);margin:auto;max-width:1100px;min-width:360px;max-height:100vh;background-color:#fff;font-size:14px;color:#464646;border:none;border-radius:4px;overflow:auto;box-shadow:0 3px 4px rgba(0,0,0,0.1),0 1px 8px rgba(0,0,0,0.05),0 2px 20px rgba(0,0,0,0.1);z-index:2;padding:0;line-height:100%;font-family:"Helvetica Neue", Helvetica, Roboto, Arial, "Lucida Grande", "PingFang TC", "蘋果儷中黑", "微軟正黑體", Microsoft JhengHei, "黑體-繁", sans-serif}.dialogify[open]{display:block}.dialogify.fixed{position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.dialogify p{line-height:1.5}.dialogify.pixel-style:before{content:"";display:block;position:absolute;top:9px;bottom:9px;left:-9px;right:-9px;background:#FFF;z-index:-1}.dialogify.pixel-style:after{content:"";display:block;position:absolute;top:4px;bottom:4px;left:-5px;right:-5px;background-color:#FFF;background-image:url(../forum/box-corner.png);background-repeat:no-repeat;background-position:-17px 100%;z-index:-1}.dialogify>div{background-repeat:no-repeat;background-position:right bottom}.dialogify>div:after{content:"";position:absolute;bottom:0;left:0;width:20px;height:21px;-webkit-transform:rotate(90deg);transform:rotate(90deg);background-size:20px;background-repeat:no-repeat;opacity:0.7}.dialogify>div hr{border:none;height:1px;background:#E0E6E8}.dialogify .dialogify__body{min-height:40px;zoom:1}.dialogify .dialogify__body:after{clear:both;content:\'.\';display:block;width:0;height:0;visibility:hidden}.dialogify .dialogify__content{padding:22px 28px 20px 24px;box-sizing:border-box}.dialogify .dialogify__content-box{margin:20px auto}.dialogify .dialogify__maxheight{max-height:400px;overflow-y:scroll;overflow-x:hidden}.dialogify .dialogify__autowidth{max-width:1100px;min-width:560px}.dialogify .dialogify__fixedwidth{max-width:560px}.dialogify .dialog__maxheight{max-height:400px;overflow-y:auto}.dialogify .dialogify__close{position:absolute;top:8px;right:8px;color:#00555f}.dialogify .dialogify__close img{width:16px;height:16px;opacity:0.85}.dialogify .dialogify__close:hover{cursor:pointer}.dialogify .dialogify__close:hover img{opacity:1}.dialogify img.dialogify-ajax-loading{position:absolute;left:50%;top:50%;width:24px;height:24px;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.dialogify a:focus{outline:none;text-decoration:none}.dialogify .btn-danger{box-shadow:0 16px 26px -10px rgba(244,67,54,0.56),0 4px 25px 0px rgba(0,0,0,0.12),0 8px 10px -5px rgba(244,67,54,0.2)}.dialogify .btn-box{margin-top:20px;clear:both}.dialogify .btn-box .btn-insert{margin-left:8px;margin-right:3px}.dialogify .btn-box .check-group{float:left;margin-top:8px}.dialogify .btn-box .check-group input[type="checkbox"]+label h6{font-size:13px;color:#A6A6A6}.dialogify .btn-box .check-group input[type="checkbox"]+label a{color:#117e96}.dialogify .btn-box .check-group input[type="checkbox"]+label a:hover{color:#126e7d;text-decoration:none;transition:all 0.3s}.dialogify .btn-box .float-left{margin-left:0}.dialogify .btn-box .float-left a{margin-left:0}.dialogify .btn-box .post__text-small{font-weight:normal}.dialogify .link-form__actions{margin-top:10px;float:right;width:100%}.dialogify .btn{display:inline-block;border:1px solid transparent;border-radius:3px;padding:5px 12px;height:auto;font-size:14px;line-height:1.5;letter-spacing:1px;cursor:pointer;background-color:#e5e5e5;color:#A6A6A6;outline:none;text-decoration:none}.dialogify .btn:hover{background:#dcdcdc;color:#A6A6A6}.dialogify .btn.is-disabled{opacity:0.5;box-shadow:inset 0 1px 1px rgba(0,0,0,0.2);cursor:not-allowed !important}.dialogify .btn.is-disabled:hover{-webkit-animation:300ms shake;animation:300ms shake}@-webkit-keyframes shake{0%{-webkit-transform:rotate(1.5deg);transform:rotate(1.5deg)}50%{-webkit-transform:rotate(-2deg);transform:rotate(-2deg)}70%{-webkit-transform:rotate(1.5deg);transform:rotate(1.5deg)}100%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}@keyframes shake{0%{-webkit-transform:rotate(1.5deg);transform:rotate(1.5deg)}50%{-webkit-transform:rotate(-2deg);transform:rotate(-2deg)}70%{-webkit-transform:rotate(1.5deg);transform:rotate(1.5deg)}100%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}.dialogify .btn.btn-primary{background-color:#117e96;color:#FFF}.dialogify .btn.btn-primary:hover{background-color:#126e7d}.dialogify .btn.btn-danger{background-color:#f44336;color:#FFF}.dialogify .btn.btn-danger:hover{background:#DE2427}.dialogify .btn.btn-danger.is-disabled:hover{background-color:#f44336}.dialogify h5.dialogify_title{font-size:18px;color:#00555f;line-height:1;margin:0 0 18px;font-family:"Helvetica Neue", Helvetica, Roboto, Arial, "Lucida Grande", "PingFang TC", "蘋果儷中黑", "Apple LiGothic Medium", "微軟正黑體", sans-serif;font-weight:normal}.dialogify h5.dialogify_title img{width:12px;height:10px;position:relative;top:-2px;margin-right:3px}.dialogify h5.dialogify_title .post__text-small img{width:12px;height:12px;top:-1px}.dialogify hr{background:#E0E6E8;border:none;height:1px;width:100%;margin-bottom:15px}.dialogify .text-right{text-align:right}.dialogify .text-center{text-align:center}.dialogify .text-left{text-align:left}.dialogify .text-field{margin:10px 0;border:1px solid #D9D9D9;border-radius:3px;padding:8px;box-sizing:border-box;width:100%;background-color:#FFF;font-size:14px;color:#00555f}.dialogify .text-field:hover,.dialogify .text-field:focus{outline:none;border-color:#117e96}.dialogify .text-field::-webkit-input-placeholder,.dialogify .text-field:-moz-placeholder,.dialogify .text-field:-ms-input-placeholder,.dialogify .text-field::-moz-placeholder{color:#B3B3B3 !important}.dialogify .text-field.is-error{border-color:#DE2427;color:#DE2427}.dialogify textarea.text-field{resize:none;min-height:100px;line-height:1.5;font-size:14px;overflow:auto}dialog::-webkit-backdrop{background:#000;opacity:.7}dialog::backdrop{background:#000;opacity:.7}dialog+.backdrop{position:fixed;top:0;left:0;right:0;bottom:0;background:#000;opacity:.7}')
            .appendTo('head')
    }

    $.fn.extend({
        enable: function(){
            if ($(this).hasClass('btn btn-insert')) {
                $(this).prop('disabled', false).removeClass('is-disabled');
            }
        },
        disable: function(){
            if ($(this).hasClass('btn btn-insert')) {
                $(this).prop('disabled', true).addClass('is-disabled');
            }
        }
    });

    window.Dialogify = Dialogify;
})(jQuery, window, dialogPolyfill);
